
<style scoped>
.card-layout {
  flex: 1 0 auto;
  width: calc(50% - 8px); 
  min-width: 180px;
  margin-right: 8px;
}

.card-layout:last-child {
  margin-right: 0px;
}
.satisfaction-text {
  width: calc(100% - 128px);
}
.satisfaction-picture {
  width: 128px; height: 128px; padding: 8px 0px 8px 16px;
}
@media only screen and (max-width: 480px) {
  .card-layout {
    width: 100%;
    margin: 16px 0px;
  }
  .satisfaction-text {
    width: 100%;
  }
  .satisfaction-picture {
    width: 196px; height: 196px; padding: 8px 0px 8px 16px;
  }
}

.star {
  height: 24px; width: 24px; color: #FAC917
}

</style>

<template>
  <div style="width: 100%; height: 100%">
    <div class="centered-child" style="padding-bottom: 16px">
      <div style="width: 100%; max-width: 200px">
      <img src="/static/trophy.svg" width="100%">
      </div>
    </div>

    <div v-if="recoursType == 'visa'">
      <h2>Apply for a visa for France</h2>
      <p>You did not apply for a visa yet. Our team can help you to build your visa application file and write a cover letter for you</p>
    </div>
    <div v-else>
      <h2>You are able to appeal after your visa refusal! </h2>
      <p>Deadlines are respected, we can help you with your visa appeal file.</p>
    </div>

    <p>You can choose the service that corresponds to your needs</p>

    <div style="display: flex; flex-wrap: wrap; justify-content: space-between; margin: 16px 0px">
      <!-- visa -->
      <md-card v-if="recoursType == 'visa'" class="card-layout light-frame">
        <md-card-media style="padding: 16px; display: flex; justify-content: center;">
          <div style="max-width: 140px;"><img src="/static/contract.svg"></div>
        </md-card-media>

        <md-card-header style="flex-grow: 2">
          <div class="md-title" style="text-align: center; padding-bottom: 8px">Help for your visa application file<br>120&euro;</div>
          <div class="md-subhead">Help for your visa application that you will have to send by yourself. A 10 minutes questionnaire, cover letter, online procedure, online support.</div>
        </md-card-header>

        <md-card-actions>
          <md-button @click="onClickDetails()">Details</md-button>
          <md-button class="md-raised md-primary" @click="onClickSelect('VISA')">Choose</md-button>
        </md-card-actions>
      </md-card>

      <!-- CRRV -->
      <md-card v-if="recoursType == 'crrv'" class="card-layout light-frame">
        <md-card-media style="padding: 16px; display: flex; justify-content: center;">
          <div style="max-width: 140px;"><img src="/static/contract.svg"></div>
        </md-card-media>

        <md-card-header style="flex-grow: 2">
          <div class="md-title" style="text-align: center; padding-bottom: 8px">Board after visa refusal<br>299&euro;</div>
          <div class="md-subhead">Appeal to the Appeals Board on Visa Refusals. 10-minutes questionnaire, online procedure, online support.</div>
        </md-card-header>

        <md-card-actions>
          <md-button @click="onClickDetails()">Details</md-button>
          <md-button class="md-raised md-primary" @click="onClickSelect('CRRV')">Choose</md-button>
        </md-card-actions>
      </md-card>

      <!-- TA -->
      <md-card v-if="recoursType == 'ta'" class="card-layout light-frame">
        <md-card-media style="padding: 16px; display: flex; justify-content: center;">
          <div style="max-width: 140px;"><img width="100%" src="/static/contract.svg"></div>
        </md-card-media>

        <md-card-header style="flex-grow: 2">
          <div class="md-title" style="text-align: center; padding-bottom: 8px">Appeal to the Administrative Court Nantes<br>299&euro;</div>
          <div class="md-subhead">Appeal to the Administrative Court of Nantes.  10-minutes questionnaire, online procedure, online support.</div>
        </md-card-header>

        <md-card-actions>
          <md-button @click="onClickDetails()">Details</md-button>
          <md-button class="md-raised md-primary" @click="onClickSelect('TA')">Choisir</md-button>
        </md-card-actions>
      </md-card>

      <!-- PREMIUM -->
      <md-card class="card-layout light-frame">
        <md-card-media style="padding: 16px; display: flex; justify-content: center; ">
          <div style="max-width: 140px;"><img width="100%" src="/static/lawyer.svg"></div>
        </md-card-media>

        <md-card-header style="flex-grow: 2">
          <div class="md-title" style="text-align: center; padding-bottom: 8px"> Premium Pack<br>999&euro;</div>
          <div class="md-subhead">You are assisted and defended by a specialised lawyer..</div>
        </md-card-header>

        <md-card-actions>
          <md-button @click="onClickDetails()">Details</md-button>
          <md-button class="md-raised md-primary" @click="onClickSelect('PREMIUM')">Choose</md-button>
        </md-card-actions>
      </md-card>
    </div>

    <!-- TrustBox widget - Micro Review Count -->
    <div class="light-frame" style="background-color: #fff; padding: 16px">
      <div style="display: flex; align-items: center; justify-content: center; align-content: center; flex-wrap: wrap">
        <img style="height: 32px" src="/static/trustedpilot.jpg" alt="">
        <div style="display: flex">
        <svg class="star"><use xlink:href="#svg-star"/></svg>
        <svg class="star"><use xlink:href="#svg-star"/></svg>
        <svg class="star"><use xlink:href="#svg-star"/></svg>
        <svg class="star"><use xlink:href="#svg-star"/></svg>
        <svg class="star"><use xlink:href="#svg-star-half"/></svg>
        <!--<svg class="star" style="color: #ccc"><use xlink:href="#svg-star"/></svg>-->
        </div>
        <div style="cursor: pointer; padding: 8px 16px; font-size: 1.1em">
          <a href="https://fr.trustpilot.com/review/getmyvisatofrance.com" target="_black">Consulter les avis clients</a>
        </div>
      </div>
    </div>


    <!--<div class="light-frame" style="display: flex; flex-direction: row; flex-wrap: wrap; align-items: center; justify-content: center; background-color: #eee;">
      <div class="satisfaction-text">
        <h2 style="text-align: center;">Satisfaction garantie à 100%</h2>
        <p>
          Nous nous engageons à vous rembourser si nous ne sommes pas en mesure de constituer votre dossier.
          La satisfaction de nos clients est notre priorité principale.
        </p>
      </div>
      <div class="satisfaction-picture">
        <img src="/static/guarantee.svg">
      </div>
    </div>-->


  </div>
</template>

<script>
import ServiceAccess from '../service/ServiceAccess'

export default {

  data: function () {
    return {
      values: null
    }
  },

  computed: {
    recoursType: function () {     
      if (this.values) {
        if (this.values.id_tiers !== 2) {
          if (this.values.id_crrv_type_recours) {
            if (this.values.id_crrv_type_recours.includes(2)) {
              return 'premium'
            } else {
              return this.values.id_crrv_type_recours.includes(1) ? 'ta' : 'crrv'
            }
          } else {
            return 'crrv'
          }
        } else {
          return 'visa'
        }
      }
    }
  },

  created: function () {

    ServiceAccess.instance.track(this.$route.params.sessionId, 'checkout-display')

    global.navigationBarBus.$on('navigation-back', this.prevScreen)
    global.navigationBarBus.$emit('navigation-display-back', true)
    global.navigationBarBus.$emit('display-save', false)


    let promises = [
      ServiceAccess.instance.loadValues(this.$route.params.sessionId)
    ]
    Promise.all(promises).then(responses => {
      let [values] = responses
      this.values = values
    })

  },
  destroyed: function () {
    global.navigationBarBus.$off('navigation-back', this.prevScreen)
  },

  methods: {
    openWithoutReferrer: function (url) {
      window.open(url, '_blank')
    },

    prevScreen: function () {
      this.$router.back()
    },

    onClickDetails: function () {
      window.open('https://www.getmyvisatofrance.com/tarifs.html', '_blank')
    },


    onClickSelect: function (item) {
      ServiceAccess.instance.track(this.$route.params.sessionId, 'checkout-item', {item: item})
      this.$router.push('/f/' + this.$route.params.sessionId + '/checkoutform/' + item)
    }

  }
}
</script>



// WEBPACK FOOTER //
// Checkout.vue?8c7ee8d6